<div class="row">
  <div class="col-sm-12">
    <mat-form-field
      [appearance]="appearance ?? 'fill'"
      class="selection-container w-100 [&_.mat-mdc-form-field-subscript-wrapper.mat-mdc-form-field-bottom-align]:hidden tight-input {{ hasError() && 'mat-form-field-invalid' }}"
      [ngClass]="{ 'select-open': isOpen, 'readonly-select': readonly }"
    >
      <mat-select
        [value]="value"
        [placeholder]="placeholder"
        (valueChange)="onSelectChange($event)"
        (openedChange)="onSelectOpened($event)"
        [disabled]="isSelectDisabled()"
        [multiple]="selectionConfig.isMultiSelect"
        class="{{ readonly ? 'dark:text-[var(--mat-color-primary)] text-[var(--mat-sys-on-surface)]!' : '' }}"
        [ngClass]="{
          '[&_.mat-mdc-select-value]:pr-6!': value,
          '[&_.mat-mdc-select-value]:pr-0!': !value
        }"
      >
        @if (selectionConfig.hasEmptyValue) {
          <mat-option></mat-option>
        }
        @if (groups.length > 0) {
          @for (group of groups; track $index) {
            <mat-optgroup [label]="group" class="f-w-500">
              @for (option of getGroupData(group); track $index) {
                <mat-option [value]="option.value" [disabled]="option.disabled">
                  @if (selectionConfig.customOptionRenderer) {
                    <ng-template *ngComponentOutlet="selectionConfig.customOptionRenderer; inputs: { option }" />
                  } @else {
                    {{ option.text | translate }}
                  }
                </mat-option>
              }
            </mat-optgroup>
          }
          @if (groups.length === 0) {
            <mat-option disabled="true">
              {{ 'no data found' | translate }}
            </mat-option>
          }
        } @else {
          @for (option of dataSource; track $index) {
            <mat-option [value]="option.value" [disabled]="option.disabled">
              @if (selectionConfig.customOptionRenderer) {
                <ng-template *ngComponentOutlet="selectionConfig.customOptionRenderer; inputs: { option }" />
              } @else {
                {{ option.text | translate }}
              }
            </mat-option>
          }
          @if (dataSource.length === 0) {
            <mat-option disabled="true">
              {{ 'no data found' | translate }}
            </mat-option>
          }
        }
      </mat-select>
      @if (loading) {
        <div class="loading-selection bg-white dark:bg-[var(--mat-card-elevated-container-color)]!">
          <mat-spinner class="spinner" diameter="20"></mat-spinner>
        </div>
      } @else {
        @if (value && !readonly) {
          <!-- clear icon -->
          <i-tabler
            name="x"
            class="icon-14 absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer hover:text-[var(--mat-sys-primary)]"
            (click)="clearInput($event)"
          />
        }
      }
    </mat-form-field>
  </div>
</div>
